///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, Input } from '@angular/core';

@Component({
    selector: 'kb-custom-html',
    templateUrl: './custom-html.component.html',
})
export class KbCustomHtmlComponent {
    @Input()
    public id: string;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/custom-html/custom-html.component.ts